import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rm-websites',
  template: `
    <div>
      <h3 class="page-title">Websites</h3>
    </div>
    <p>These are some of the websites I've worked on in the past.</p>
    <div class="web-templates">
      <rm-web-template title="Neversummer" imgUrl="assets/images/website/neversummer.jpg" desc="{{website1.webDesc}}"></rm-web-template>
      <rm-web-template title="Comet Empire" imgUrl="assets/images/website/comet.png" desc="{{website1.webDesc}}"></rm-web-template>
      <rm-web-template title="BuySellTrains" imgUrl="assets/images/website/bst.jpg" desc="{{website1.webDesc}}"></rm-web-template>
      <rm-web-template title="Cenegenics" imgUrl="assets/images/website/cengenics.jpg" desc="{{website1.webDesc}}"></rm-web-template>
      <rm-web-template title="Custom Truck HQ" imgUrl="assets/images/website/customTruck.jpg" desc="{{website1.webDesc}}"></rm-web-template>
      <rm-web-template title="Golden Retriever Rescue" imgUrl="assets/images/website/grrr.jpg" desc="{{website1.webDesc}}"></rm-web-template>
      <rm-web-template title="Jumpstreet" imgUrl="assets/images/website/jump.jpg" desc="{{website1.webDesc}}"></rm-web-template>
      <rm-web-template title="Kitchen and Bath Wizards" imgUrl="assets/images/website/kbwiz.jpg" desc="{{website1.webDesc}}"></rm-web-template>
      <rm-web-template title="Body Massage Wellness Spa" imgUrl="assets/images/website/mass.jpg" desc="{{website1.webDesc}}"></rm-web-template>
      <rm-web-template title="Mile High Gutter" imgUrl="assets/images/website/mhg.jpg" desc="{{website1.webDesc}}"></rm-web-template>
      <rm-web-template title="Neversummer Germany" imgUrl="assets/images/website/nsde.jpg" desc="{{website1.webDesc}}"></rm-web-template>
      <rm-web-template title="One Clear Choice" imgUrl="assets/images/website/occ.jpg" desc="{{website1.webDesc}}"></rm-web-template>
      <rm-web-template title="Pretty Functions" imgUrl="assets/images/website/pf.jpg" desc="{{website1.webDesc}}"></rm-web-template>
    </div>
  `,
  styleUrls: ['./websites.component.scss']
})
export class WebsitesComponent implements OnInit {
  public website1 = {
    title: 'Test Website',
    imgPlcHolderUrl: 'http://via.placeholder.com/300x150',
    webDesc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin varius id tellus in fermentum. Morbi sed ligula felis. Vivamus dignissim vehicula diam malesuada facilisis. '
  };

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/websites/websites.component.ts